/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Output_LocaleInputs */



/**
* | output |
* | --- |
* | "Output Locale" |
*
* @param {Output_LocaleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const output_locale = /** @type {((inputs?: Output_LocaleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Output_LocaleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Locale de sortie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgabegebietsschema")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni locali di output")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Локаль вывода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración regional de salida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输出区域设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("出力ロケール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आउटपुट लोकेल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Local de saída")
	return /** @type {LocalizedString} */ ("Output Locale")
});